(function () {
  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.classList.add("is-open");
    document.body.classList.add("vip-modal-open");

    // focus close button for accessibility
    const closeBtn = modal.querySelector("[data-vipm-close]");
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.hidden = true;
    document.body.classList.remove("vip-modal-open");
  }

  function getModalFromTrigger(trigger) {
    const id = trigger.getAttribute("data-vipm-open");
    if (!id) return null;
    // id is like "vip-modal-123456789"
    return document.getElementById(id);
  }

  // Click to open
  document.addEventListener("click", function (e) {
    const openTrigger = e.target.closest("[data-vipm-open]");
    if (openTrigger) {
      e.preventDefault();
      const modal = getModalFromTrigger(openTrigger);
      openModal(modal);
      return;
    }

    const closeTrigger = e.target.closest("[data-vipm-close]");
    if (closeTrigger) {
      const modal = e.target.closest(".vip-modal");
      closeModal(modal);
    }
  });

  // Keyboard support for span role="button"
  document.addEventListener("keydown", function (e) {
    const active = document.activeElement;

    // open with Enter/Space
    if ((e.key === "Enter" || e.key === " ") && active && active.matches("[data-vipm-open]")) {
      e.preventDefault();
      const modal = getModalFromTrigger(active);
      openModal(modal);
      return;
    }

    // close on Escape
    if (e.key === "Escape") {
      const openModalEl = document.querySelector(".vip-modal.is-open");
      if (openModalEl) closeModal(openModalEl);
    }
  });
})();
